import { render, staticRenderFns } from "./Busses.vue?vue&type=template&id=280ff0c7"
import script from "./Busses.vue?vue&type=script&lang=js"
export * from "./Busses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports